import { Model } from 'modules/core/lib/mobx-rest'

interface IPlanningVersion {
  id: number
  employee_id: number
  effective_at: string
  planning_tool: string
  schedule_id?: number
}

class PlanningVersion extends Model<IPlanningVersion> {
  static urlRoot() {
    return '/shift_management/planning_versions'
  }
}

export default PlanningVersion
